module.exports = __webpack_public_path__ + "img/about-high-res.a8d81f61.png";